import { Atom } from 'AppReact';
import styled from "styled-components";

const template = styled.div`
    font-size: 8px;
    padding: 2px 5px;
    background: #1a732f;
    color: white;
    border-radius: 5px;
`;


export default Atom({ type: 'label', dataType: 'string', template })
